'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useEffect, useRef } from 'react';
import FacebookIcon from '@/assets/icons/facebook-news.svg';
import XIcon from '@/assets/icons/linkedIn-news.svg';
import LinkedInIcon from '@/assets/icons/X-news.svg';
export default function NewsShareButtons(t0) {
  const $ = _c(19);
  const {
    title
  } = t0;
  const safeTitle = title || "";
  const facebookRef = useRef(null);
  const linkedInRef = useRef(null);
  const xRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== safeTitle) {
    t1 = () => {
      const currentUrl = window.location.href;
      const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;
      const linkedInUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(currentUrl)}&title=${encodeURIComponent(safeTitle)}`;
      const xUrl = `https://x.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(safeTitle)}`;
      if (facebookRef.current) {
        facebookRef.current.href = facebookUrl;
      }
      if (linkedInRef.current) {
        linkedInRef.current.href = linkedInUrl;
      }
      if (xRef.current) {
        xRef.current.href = xUrl;
      }
    };
    t2 = [safeTitle];
    $[0] = safeTitle;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const handleShare = _temp;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="lg:text-xs text-base leading-[22px] lg:font-medium font-semibold lg:text-[#757575] text-[#323232]">Share Article</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = handleShare(_temp2);
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <a href="#" ref={facebookRef} onClick={t4} target="_blank" rel="noopener noreferrer" className="flex h-9.5 w-9.5 items-center justify-center rounded-[4px] bg-white text-[#323232] "><Image src={FacebookIcon} alt="Share on Facebook" className="h-4.5 w-4.5" /></a>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== safeTitle) {
    t6 = handleShare(url_0 => `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url_0)}&title=${encodeURIComponent(safeTitle)}`);
    $[6] = safeTitle;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Image src={LinkedInIcon} alt="Share on LinkedIn" className="h-4.5 w-4.5" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <a href="#" ref={linkedInRef} onClick={t6} target="_blank" rel="noopener noreferrer" className="flex h-9.5 w-9.5 items-center justify-center rounded-md bg-white text-[#2B2B2B] ">{t7}</a>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== safeTitle) {
    t9 = handleShare(url_1 => `https://x.com/intent/tweet?url=${encodeURIComponent(url_1)}&text=${encodeURIComponent(safeTitle)}`);
    $[11] = safeTitle;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Image src={XIcon} alt="Share on X" className="h-4.5 w-4.5" />;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t9) {
    t11 = <a href="#" ref={xRef} onClick={t9} target="_blank" rel="noopener noreferrer" className="flex h-9.5 w-9.5 items-center justify-center rounded-md bg-white text-[#2B2B2B]">{t10}</a>;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t8) {
    t12 = <div>{t3}<div className="mt-2 flex flex-wrap gap-1">{t5}{t8}{t11}</div></div>;
    $[16] = t11;
    $[17] = t8;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
}
function _temp2(url) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
}
function _temp(buildUrl) {
  return event => {
    event.preventDefault();
    const currentUrl_0 = window.location.href;
    const shareUrl = buildUrl(currentUrl_0);
    window.open(shareUrl, "_blank", "noopener,noreferrer");
  };
}